import React from 'react'
import PropTypes from 'prop-types'

import Text from '../../../Text'

const Paragraph = (props) => {
  const { boxProps, children } = props

  return (
    <Text
      color="bodyFontLightColor"
      fontSize="xsmall"
      lineHeight="1.3"
      marginTop="medium"
      {...boxProps}
    >
      {children}
    </Text>
  )
}

Paragraph.propTypes = {
  boxProps: PropTypes.object,
  children: PropTypes.node,
}

export default Paragraph
